// extracted by mini-css-extract-plugin
module.exports = {"delete":"styles_delete__l9Y7A"};